import { CardSuggestion } from "@models/card-suggestion.model";
import { BaseConverter } from "./BaseConverter";
import { CardSuggestionDto } from "@dtos/card-suggestion.dto";
import { CardInfoConverter } from "./cardInfoConverter";

export class CardSuggestionConverter extends BaseConverter<CardSuggestion, CardSuggestionDto>{
    private cardInfoConverter = new CardInfoConverter()
    modelToDto(model: CardSuggestion): CardSuggestionDto {
        return new CardSuggestionDto(
            model.id,
            model.displaySorting,
            model.photo,
            model.cardInfo? this.cardInfoConverter.modelToDto(model.cardInfo) : undefined
        )
    }

    dtoToModel(dto: CardSuggestionDto): CardSuggestion {
        return new CardSuggestion(
            dto.id,
            dto.displaySorting,
            dto.photo,
            dto.cardInfo? this.cardInfoConverter.dtoToModel(dto.cardInfo) : undefined
        )
    }
}